import React, {useEffect, useEffectEvent, useState} from 'react';
import type {NoProps} from 'types';
import {useLocalization} from 'localization';
import {useAuthState} from 'services/auth/hooks/useAuthState';
import {ActionButtonV2} from 'components/button/ActionButtonV2';
import {AppAnon} from 'app/AppAnon';

type Props = NoProps;

export const Login: React.FC<Props> = () => {
  const {login, canAttemptAutoSignin} = useAuthState();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);
  const onSetHasTriedSignin = useEffectEvent(setHasTriedSignin);

  const {t} = useLocalization();

  // automatically sign-in
  useEffect(() => {
    if (canAttemptAutoSignin() && !hasTriedSignin) {
      login();
      onSetHasTriedSignin(true);
    }
  }, [canAttemptAutoSignin, hasTriedSignin, login]);

  return (
    <AppAnon>
      <ActionButtonV2 title={t('page.login.log_in')} onClick={login} />
    </AppAnon>
  );
};
